
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./immer.cjs.production.min.js')
} else {
  module.exports = require('./immer.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/immer/dist/index.js
// module id = 2034
// module chunks = 0